export const SearchPageName: { [k: string]: string } = {
  SA: 'page.Hotel-Search',
  HC: 'page.Package.HC.Hotel-Search',
  FH: 'page.Package.FH.Hotel-Search',
  FHC: 'page.Package.FHC.Hotel-Search',
};

export enum InfositePageName {
  SA = 'page.Hotels.Infosite.Information',
  HC = 'page.HC.Package.Infosite.Information',
  FH = 'page.FH.Package.Infosite.Information',
  FHC = 'page.FHC.Package.Infosite.Information',
  FC = '',
}

export const SEARCH_PAGE_EG_CLICKSTREAM_NAME = 'Search Results';

export const SearchClickstreamPageNameDetailed: { [k: string]: string } = {
  SA: 'Search Results Lodging Dated',
  HC: 'Search Results HC Package Hotel',
  FH: 'Search Results FH Package Hotel',
  FHC: 'Search Results FHC Package Hotel',
};

export enum SearchMapClickstreamPageNameDetailed {
  SA = 'Search Results Map Lodging Dated',
  HC = 'Search Results Map HC Package Hotel',
  FH = 'Search Results Map FH Package Hotel',
  FHC = 'Search Results Map FHC Package Hotel',
}

export const INFOSITE_PAGE_EG_CLICKSTREAM_NAME = 'Product Details';

export enum DetailsClickstreamPageNameDetailed {
  SA = 'Product Details Lodging Dated',
  HC = 'Product Details HC Package Hotel',
  FH = 'Product Details FH Package Hotel',
  FHC = 'Product Details FHC Package Hotel',
  FC = '',
}

// These names do not conform to what's found here: https://confluence.expedia.biz/display/DAPS/Clickstream+-+cross+brand+page+names
export enum InfositePageEgClickstreamDetailedName {
  SA = 'Product Details Lodging',
  HC = 'Product Details Package Lodging (Lodging+Car)',
  FH = 'Product Details Package Lodging (Flight+Lodging)',
  FHC = 'Product Details Package Lodging (Flight+Lodging+Car)',
}
